mutation deleteProject($id: ID!) {
	deleteProject(id: $id)
}